import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLazyGetUserUplineQuery } from '../services/auth/authApi';

const SearchUserPage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  
  const [getUserUpline, { isLoading }] = useLazyGetUserUplineQuery();

  const handleSearch = async () => {
    if (searchQuery.trim()) {
      try {
        const result = await getUserUpline(searchQuery.trim()).unwrap();
        if (result.success && result.data) {
          // Combine user and upline into a single array
          const allUsers = [];
          if (result.data.user) {
            allUsers.push(result.data.user);
          }
          if (result.data.upline && Array.isArray(result.data.upline)) {
            allUsers.push(...result.data.upline);
          }
          setSearchResults(allUsers);
        } else {
          setSearchResults([]);
        }
      } catch (error) {
        console.error('Search error:', error);
        setSearchResults([]);
      }
    }
  };

  const getRoleColor = (role) => {
    // Return gradient color based on role
    return 'bg-gradient-to-br from-orange-400 to-red-500';
  };

  return (
    <div className="w-full min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-[#1a3a3a] px-6 py-4 flex justify-between items-center">
        <h1 className="text-white text-2xl font-medium">Search User</h1>
        <button
          onClick={() => navigate(-1)}
          className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded font-medium"
        >
          Back
        </button>
      </div>

      {/* Search Bar */}
      <div className="bg-white p-2">
        <div className="flex gap-3 max-w-xl">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            placeholder="C7"
            className="w-96 border border-gray-300 px-4 py-2 text-base rounded focus:outline-none focus:border-blue-500"
            disabled={isLoading}
          />
          <button
            onClick={handleSearch}
            disabled={isLoading}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Searching...' : 'Search'}
          </button>
        </div>
      </div>

      {/* Results Grid */}
      <div className="p-8">
        <div className="flex flex-wrap gap-6">
          {searchResults.map((user, index) => (
            <div
              key={index}
              className={`${getRoleColor(user.hierarchyLevel || user.userType)} rounded-lg p-6 text-white shadow-lg cursor-pointer hover:shadow-xl transition-shadow`}
            >
              <div className="flex items-start gap-3">
                {/* User Icon */}
                <div className="bg-opacity-30 rounded-full p-3">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>

                {/* User Info */}
                <div className="flex-1">
                  <h3 className="text-lg font-bold mb-1">
                    {user.fullName || user.name || user.username}({user.userId})
                  </h3>
                  <p className="text-white text-opacity-90 text-sm">{user.userType || user.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {searchResults.length === 0 && searchQuery && !isLoading && (
          <div className="text-center py-16 text-gray-500 text-lg">
            No users found
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchUserPage;
